export default __webpack_public_path__ + "static/media/logo.071ce0a5.png";